export class Tools{
    public static dateTimeDistanceFormatter(item:any):string{
        var ret:string = '';
        if ( item.startDate !== '' && item.startDate !== '0000-00-00'  ) {
            ret += this.dateFormat(item.startDate);
        }
        item.startTime = this.timeFormat(item.startTime);
        item.endTime = this.timeFormat(item.endTime);
        var noTimeMode:boolean = false;
        if ( item.startTime === '00:00' && item.endTime === '00:00' ) {
            noTimeMode = true;
        }



        if ( noTimeMode === false && item.startTime !== '00:00' ) {
            ret += ' ' + item.startTime;
        }
        var endDateAdded:boolean = false;
        if ( item.endDate !== '' && item.endDate !== '0000-00-00' && item.startDate !== item.endDate ) {
            ret += ' - ' + this.dateFormat(item.endDate);
            endDateAdded = true;
        }
        if ( noTimeMode === false && (item.startDate + item.startTime) !== (item.endDate + item.endTime)  ) {
            if ( endDateAdded === false ) {
                ret += ' - ' + item.endTime;
            }else{
                ret += ' ' + item.endTime;
            }
        }
        return ret;
    }

    public static timeFormat(str:string):string{
        var temp:Array<string> = str.split(':');
        return temp[0]+':'+temp[1];
    }

    public static dateFormat(str:string):string{
        var temp:Array<string> = str.split('-');
        return temp.join('.')+'.';
    }
}



// WEBPACK FOOTER //
// ./lib/Tools.ts